import type { Dayjs } from "dayjs";
import dayjs from "dayjs";

import type { ISwSettings } from "app/@types/ISwSettings";
import { swSettings } from "app/common/services/swSettings";

import type { IAlertsComponent } from "../../../types/IAlertsComponent";

export const getAlertsSupportedWindowDate = (): Dayjs | undefined => {
    const componentConfig = (swSettings as ISwSettings<IAlertsComponent>).components.Alerts;
    const rawSupportedWindowDate = componentConfig?.resources?.SupportedWindowDate;
    const supportedWindowDate = typeof rawSupportedWindowDate === "string" ? rawSupportedWindowDate : undefined;

    if (!supportedWindowDate) {
        return undefined;
    }

    const parsed = dayjs.utc(supportedWindowDate);

    return parsed.isValid() ? parsed : undefined;
};
